// 分数データから時間と分を求める関数
const convertToHoursAndMinutes = (totalMin: number) => {
  const partialHour = Math.floor(totalMin / 60); // 時間部分を計算
  const partialMin = totalMin % 60; // 残りの分を計算
  return { partialHour, partialMin };
};

// 時間と分から合計の分数を計算する関数
const convertToTotalMinutes = (
  partialHour: number,
  partialMin: number
  // isBreak: boolean
) => {
  let totalMin = partialHour * 60 + partialMin;
  // if (isBreak) {
  //   totalMin += 30;
  // }
  if (totalMin < 0) {
    totalMin = 0;
  }
  let totalHours = Math.round((totalMin / 60) * 100) / 100; // 小数点第2位で四捨五入
  return {
    min: totalMin, // 合計の分数
    hours: totalHours, // 時間換算した値（小数点第2位まで）
  };
};
export { convertToHoursAndMinutes, convertToTotalMinutes };
